import {
  FETCH_ORDER_ITEMS_LOADING,
  FETCH_ORDER_ITEMS,
  SAVE_BOOKING_ORDER,
  SOCKET_NEW_BOOKING_ORDER,
  SOCKET_REFETCH_BOOKING_ORDER,
  UPDATE_CUSTOMER_BOOKING_STATUS,
  EDIT_BOOKING_DATE_AND_TIME,
} from "../actions/actionTypes";

const initialState = {
  orderItems: [],
  products: [],
  loading: false,
  didFullyLoad: false,
  newItem: null,
  shouldRefetch: false,
};

export default (state = initialState, { type, payload, asyncDispatch }) => {
  switch (type) {
    case FETCH_ORDER_ITEMS_LOADING:
      return { ...state, loading: true };

    case FETCH_ORDER_ITEMS:
      return {
        ...state,
        orderItems: payload.items,
        products: payload.products,
        loading: false,
        didFullyLoad: true,
      };

    /* ---------------- SAVE BOOKING ORDER ---------------- */

    case SAVE_BOOKING_ORDER: {
      const { bookingID, orderObj } = payload;
      const items = state.orderItems;

      // Calendar / flat mode
      if (Array.isArray(items)) {
        return {
          ...state,
          orderItems: items.map((item) =>
            item.order__tracking_id === bookingID
              ? {
                  ...item,
                  order_obj: orderObj,
                  order__payment_method: orderObj.payment_method,
                }
              : item
          ),
        };
      }

      // Table / paginated mode
      const updated = {};
      Object.keys(items || {}).forEach((key) => {
        updated[key] = Array.isArray(items[key])
          ? items[key].map((item) =>
              item.order__tracking_id === bookingID
                ? {
                    ...item,
                    order_obj: orderObj,
                    order__payment_method: orderObj.payment_method,
                  }
                : item
            )
          : items[key];
      });

      return {
        ...state,
        orderItems: updated,
      };
    }

    /* ---------------- SOCKETS ---------------- */

    case SOCKET_REFETCH_BOOKING_ORDER:
      return { ...state, shouldRefetch: payload };

    case SOCKET_NEW_BOOKING_ORDER: {
      const newOrderItems = state.didFullyLoad ? [payload, ...state.orderItems] : state.orderItems;

      if (window.location.pathname === "/manage/bookings") {
        window.setTimeout(() => {
          asyncDispatch((dispatch) => dispatch({ type: "RESET_NEW_ITEM" }));
        }, 7000);
      }

      return {
        ...state,
        orderItems: newOrderItems,
        newItem: payload.id,
      };
    }

    case "RESET_NEW_ITEM":
      return { ...state, newItem: null };

    /* ---------------- UPDATE STATUS ---------------- */

    case UPDATE_CUSTOMER_BOOKING_STATUS: {
      const updated = state.orderItems.map((item) => (item.order_id === payload.order_id ? { ...item, order_status: payload.status } : item));

      return { ...state, orderItems: updated };
    }

    /* ---------------- EDIT DATE & TIME ---------------- */

    case EDIT_BOOKING_DATE_AND_TIME: {
      const { orderItem } = payload;
      const items = state.orderItems;

      if (Array.isArray(items)) {
        return {
          ...state,
          orderItems: items.map((item) => (item.id === orderItem.id ? { ...item, ...orderItem } : item)),
        };
      }

      const updated = {};
      Object.keys(items || {}).forEach((key) => {
        updated[key] = Array.isArray(items[key]) ? items[key].map((item) => (item.id === orderItem.id ? { ...item, ...orderItem } : item)) : items[key];
      });

      return {
        ...state,
        orderItems: updated,
      };
    }

    default:
      return state;
  }
};
